import { Card, CardContent } from "@/components/ui/card";
import { MathApp } from "./components/MathApp";
import "./index.css";

export function App() {
  return (
    <div className="min-h-screen flex items-start justify-center p-8 text-center relative z-10">
      <Card className="w-full max-w-4xl bg-card/50 backdrop-blur-sm border-muted mx-auto">
        <CardContent className="pt-6">
          <h1 className="text-5xl font-bold my-4 leading-tight">Math Practice</h1>
          <MathApp />
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
